<app-dialog-base [showLoadingSpinner]="isLoading()">
  <div dialog-title>
    @if (isConvertingToGameSpecific) {
      <mat-icon class="align-middle me-2 text-primary">videogame_asset</mat-icon>
      Convert to Game-Specific FAQ
    } @else {
      <mat-icon class="align-middle me-2 text-primary">settings</mat-icon>
      Manage Game Associations
    }
  </div>

  <div dialog-content>
    <!-- FAQ Info -->
    <div class="bg-primary bg-opacity-10 border-start border-primary border-4 p-3 rounded mb-4">
      <div class="small fw-semibold text-secondary mb-1">FAQ Question:</div>
      <div>{{ faq.Question }}</div>
    </div>

    @if (isConvertingToGameSpecific) {
      <div class="alert alert-info d-flex align-items-center gap-2 mb-3">
        <mat-icon class="flex-shrink-0">info</mat-icon>
        <span>Select which games should display this FAQ. The FAQ will no longer be available to all games.</span>
      </div>
    }

    <app-faq-game-selector [initialSelectedGameIds]="initialSelectedGameIds"></app-faq-game-selector>
  </div>

  <div actions>
    <button mat-raised-button
            color="primary"
            (click)="onSave()"
            [disabled]="isLoading()">
      <mat-icon>save</mat-icon>
      {{ isConvertingToGameSpecific ? 'Convert & Save' : 'Save Changes' }}
    </button>
  </div>
</app-dialog-base>
